import React from 'react';

import classnames from 'classnames';
import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';
import Link from 'src/components/Link';
import { IMenu } from 'src/shared/models';

const FooterConsumerCols = (menuConfig: IMenu[]) => {
  const { pathname } = useRouter();
  const handleConsentManagerClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // @ts-ignore
    __cmp('showScreen');
  };
  const menuFooterCol1 = menuConfig?.filter(
    (_menuItem) => _menuItem?.order === 1,
  )[0];

  const menuFooterCol2 = menuConfig?.filter(
    (_menuItem) => _menuItem?.order === 2,
  )[0];

  const menuFooterCol3 = menuConfig?.filter(
    (_menuItem) => _menuItem?.order === 3,
  )[0];

  const renderTitle = (title: string) => {
    return title && title !== ' ' ? (
      <div className="menu-title">{title}</div>
    ) : (
      <></>
    );
  };

  const renderMenu = (menu: IMenu) => {
    return menu?.subMenu?.map(
      ({ idMenu, disabled, absolute, href, hrefAs, name }) => {
        return absolute ? (
          <a
            key={idMenu}
            href={hrefAs}
            target="_blank"
            className={`menu-item con-footer-app-menu__menu-item link underline-text ${
              disabled ? 'disabled' : ''
            }`}
            rel="noreferrer">
            {name}
          </a>
        ) : (
          <li
            key={idMenu}
            className={`menu-item  con-footer-app-menu__menu-item ${
              disabled ? 'disabled' : ''
            }`}>
            <Link href={href} as={hrefAs} passHref={true} shallow={false}>
              <a>{name}</a>
            </Link>
          </li>
        );
      },
    );
  };

  return (
    <>
      <div
        className={classnames('con-footer-app-menu__columns', {
          'con-footer-app-menu__columns__center':
            !menuFooterCol2 && !menuFooterCol3,
          'con-footer-app-menu__columns__multi':
            menuFooterCol2 || menuFooterCol3,
        })}>
        {menuFooterCol1 && (
          <ul
            className={classnames('con-footer-app-menu__column', {
              'con-footer-app-menu__column__center':
                !menuFooterCol2 && !menuFooterCol3,
            })}>
            {renderTitle(menuFooterCol1.name)}
            {renderMenu(menuFooterCol1)}
          </ul>
        )}
        {menuFooterCol3 && (
          <div>
            {renderTitle(menuFooterCol2.name)}
            {renderMenu(menuFooterCol1)}
          </div>
        )}
        {menuFooterCol3 && (
          <div>
            {renderTitle(menuFooterCol3.name)}
            {renderMenu(menuFooterCol3)}
          </div>
        )}
        <ul className="con-footer-app-menu__column con-footer-app-menu__column__center">
          <li className="menu-item con-footer-app-menu__menu-item">
            <a id="ot-sdk-btn" href={`${pathname}?cmpscreen`} onClick={handleConsentManagerClick}>
              <FormattedMessage id="app.coockie-settings" />
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default FooterConsumerCols;
